/* PLU Experience Rebuild (Round 2) shared behaviors:
   scroll reveals, stat counters, hero video gating.
   Idempotent: safe to include from multiple sections. */
(function () {
  if (window.__plu2Loaded) return;
  window.__plu2Loaded = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count'));
    if (isNaN(target)) return;
    var decimals = (el.getAttribute('data-count').split('.')[1] || '').length;
    if (reducedMotion || !('requestAnimationFrame' in window)) {
      el.querySelector('[data-count-num]').textContent = target.toFixed(decimals);
      return;
    }
    var duration = 1400;
    var startTime = null;
    var numEl = el.querySelector('[data-count-num]');
    function step(ts) {
      if (!startTime) startTime = ts;
      var p = Math.min((ts - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      numEl.textContent = (eased * target).toFixed(decimals);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function init(scope) {
    scope = scope || document;

    // Scroll reveals
    var reveals = scope.querySelectorAll('.plu2-reveal:not([data-plu2-bound])');
    if (reveals.length) {
      if (!('IntersectionObserver' in window) || reducedMotion) {
        reveals.forEach(function (el) { el.classList.add('is-in'); el.setAttribute('data-plu2-bound', ''); });
      } else {
        var revealObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); revealObs.unobserve(e.target); }
          });
        }, { threshold: 0.18 });
        reveals.forEach(function (el) { el.setAttribute('data-plu2-bound', ''); revealObs.observe(el); });
      }
    }

    // Stat counters
    var counters = scope.querySelectorAll('[data-count]:not([data-plu2-bound])');
    if (counters.length) {
      if (!('IntersectionObserver' in window)) {
        counters.forEach(function (el) { el.setAttribute('data-plu2-bound', ''); animateCount(el); });
      } else {
        var countObs = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { animateCount(e.target); countObs.unobserve(e.target); }
          });
        }, { threshold: 0.4 });
        counters.forEach(function (el) { el.setAttribute('data-plu2-bound', ''); countObs.observe(el); });
      }
    }

    // Hero background video: play only in view, never with reduced motion
    var videos = scope.querySelectorAll('video[data-plu2-video]:not([data-plu2-bound])');
    videos.forEach(function (video) {
      video.setAttribute('data-plu2-bound', '');
      if (reducedMotion) { video.removeAttribute('autoplay'); video.pause(); return; }
      if (!('IntersectionObserver' in window)) { video.play().catch(function () {}); return; }
      var vidObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.play().catch(function () {}); }
          else { e.target.pause(); }
        });
      }, { threshold: 0.1 });
      vidObs.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
